import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {ApiUrl} from '@emm/core/util/api-url.token';
import { Attribute } from '../models/attribute.model';
import {API} from '@emm/core/util/api-constants';
import {standardRetry} from '@emm/core/util/rx.util';
import {AttributeType} from '@emm/core/models/attribute-type.model';


@Injectable({ providedIn: 'root' })
export class AttributeService {
    constructor(@Inject(ApiUrl) private apiUrl: string, private http: HttpClient) {}

    public getAllAttributes(): Observable<Attribute[]> {
        const url = `${this.apiUrl}${API.AllAttributes}`;
        return this.http.get(url).pipe(
            map((response: any) => response),
            standardRetry()
        );
    }

    public getAllGlobalAttributes(): Observable<Attribute[]> {
        const url = `${this.apiUrl}/attributes/findAll/GLOBAL`;
        return this.http.get(url).pipe(
            map((response: any) => response),
            standardRetry()
        );
    }

    public getAttributeExclusionsByConsumer(consumerTag: string): Observable<string[]> {
        const url = `${this.apiUrl}/consumers/${consumerTag}/attribute-exclusions`;
        return this.http.get<string[]>(url).pipe(standardRetry());
    }

    public updateAttributeExclusionsByConsumer(consumerTag: string, attributeTags: string[]): Observable<string[]> {
        const url = `${this.apiUrl}/consumers/${consumerTag}/attribute-exclusions`;
        return this.http
            .post(url, attributeTags)
            .pipe(standardRetry());
    }

    public getAttribute(attributeTag: string): Observable<Attribute> {
        return this.http
            .get<Attribute>(`${this.apiUrl}/attributes/${attributeTag}`)
            .pipe(standardRetry());
    }

    public updateAttribute(attribute: Attribute): Observable<Attribute> {
        return this.http
            .put(`${this.apiUrl}/attributes/${attribute.tag}`, {
                itemTypes: attribute.itemTypeScope,
                options: attribute.options,
            })
            .pipe(standardRetry());
    }

    public createAttribute(attribute: {
        attributeGroup: string,
        defaultValue: string;
        description: any;
        jsonProperty: any;
        localeSupport: boolean;
        locked: boolean;
        name: any;
        options: string;
        required: boolean;
        scope: any;
        sortWeight: any;
        tag: any;
        typetag: any;
    }): Observable<any> {
        return this.http
            .post(this.apiUrl + '/attributes', attribute, { responseType: 'text' })
            .pipe(standardRetry());
    }

    public deleteAttribute(attributeTag: string): Observable<any> {
        return this.http.delete(this.apiUrl + '/attributes/' + attributeTag).pipe(standardRetry());
    }

    public getAllAttributeTypes(): Observable<AttributeType[]> {
        return this.http.get<AttributeType[]>(this.apiUrl + '/attribute-types').pipe(standardRetry());
    }

    public getAttributeOverrides(attribute: string, submenu: string, itemPath: string, effectiveDate: string): Observable<any> {
        return this.http.get(this.apiUrl +
            `/location/overrides/attribute/locations?attribute=${attribute}&submenu=${submenu}&itemPath=${itemPath}&effectiveDate=${effectiveDate}`)
    }

    public getParentOverrides(attribute: string, location: string, submenu: string, effectiveDate: string,
                              itemPath: string, language: string) {
        return this.http.get(this.apiUrl +
            `/location/overrides/attribute/parent?location=${location}&submenu=${submenu}&effectiveDate=${effectiveDate}` +
            `&attribute=${attribute}&itemPath=${itemPath}&language=${language}`, {
            responseType: 'text'
        });
    }
}
